import type { Incoterms } from 'api';
import { number } from 'yup';

export const createIncotermDependentValidation = (
  requiredIncoterms: readonly Incoterms[],
  incotermField = 'incoterm'
) => {
  return number().when(incotermField, {
    is: (incoterm: Incoterms) => requiredIncoterms.includes(incoterm),
    otherwise: (schema) => schema.notRequired(),
    then: (schema) => schema.required(),
  });
};
